import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-obstacle-view-actions-bar',
  templateUrl: './obstacle-view-actions-bar.component.html',
  styleUrls: ['./obstacle-view-actions-bar.component.scss'],
  standalone: false,
})
export class ObstacleViewActionsBarComponent {
  @Input() public isLegendVisible = false

  @Output() public toggleLegend = new EventEmitter<void>()
}
